import React from 'react';
import { Section, FadeIn } from './ui';
import { CalendarClockIcon, Users2Icon, BarChart4Icon } from 'lucide-react';
export function Solution() {
  const stages = [{
    icon: <CalendarClockIcon className="w-8 h-8" data-id="element-6711" />,
    title: 'Before',
    color: 'text-brand-teal',
    bg: 'bg-brand-teal/10',
    items: ['Attendee intake', 'Goals and preferences', 'Introductions', 'AI-generated agenda']
  }, {
    icon: <Users2Icon className="w-8 h-8" data-id="element-6712" />,
    title: 'During',
    color: 'text-brand-coral',
    bg: 'bg-brand-coral/10',
    items: ['Event hub', 'Prompts and sessions', 'Group matching', 'Activity signups']
  }, {
    icon: <BarChart4Icon className="w-8 h-8" data-id="element-6713" />,
    title: 'After',
    color: 'text-brand-navy',
    bg: 'bg-brand-navy/10',
    items: ['Feedback', 'Commitments', 'Analytics', 'Client-ready report']
  }];
  return <Section className="bg-slate-50" data-id="element-6714">
      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-6715">
        <FadeIn data-id="element-6716">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-6717">
            The engagement layer for meetings, retreats, and group stays.
          </h2>
        </FadeIn>
      </div>

      <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-6718">
        {/* Connecting Line (Desktop) */}
        <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-slate-200 z-0" data-id="element-6719"></div>

        {stages.map((stage, i) => <FadeIn key={i} delay={i * 0.2} className="relative z-10" data-id="element-6720">
            <div className="bg-white rounded-2xl p-8 shadow-soft border border-slate-100 h-full flex flex-col items-center text-center" data-id="element-6721">
              <div className={`${stage.bg} ${stage.color} p-4 rounded-2xl mb-6`} data-id="element-6722">
                {stage.icon}
              </div>
              <h3 className="text-2xl font-bold text-brand-navy mb-6" data-id="element-6723">
                {stage.title}
              </h3>
              <ul className="space-y-4 w-full text-left" data-id="element-6724">
                {stage.items.map((item, j) => <li key={j} className="flex items-center gap-3 text-slate-700 font-medium" data-id="element-6725">
                    <div className={`w-1.5 h-1.5 rounded-full ${stage.color.replace('text-', 'bg-')}`} data-id="element-6726"></div>
                    {item}
                  </li>)}
              </ul>
            </div>
          </FadeIn>)}
      </div>
    </Section>;
}